import { EThreadPermission, IThread } from '../api/models/thread/thread.types';
import { INormalizedThreads } from '../api/repositories/thread/thread.normalizer';
import { ActionsUnion, createAction } from '../helpers';
import { IPaginationMetadata } from '../helpers/pagination';
import { IMessagesEntries } from '../messages/types';

// SINGLE THREAD

export enum EThreadActionType {
  GET = 'THREAD/GET',
  GET_SUCCESS = 'THREAD/GET_SUCCESS',
  CHECK_PERMISSION_ERROR = 'THREAD/CHECK_PERMISSION_ERROR',
  SET_AS_READ = 'THREAD/SET_AS_READ',
  RESET = 'THREAD/RESET',
  NEW_MESSAGE = 'THREAD/NEW_MESSAGE',
  DELETE_UNSENT_MESSAGE = 'THREAD/DELETE_UNSENT_MESSAGE',
}

export const threadActions = {
  newThreadFromWebsocket: (thread: IThread) =>
    createAction(EThreadActionType.NEW_MESSAGE, thread),
  getThread: (otherAccountId: string) =>
    createAction(EThreadActionType.GET, { otherAccountId }),
  getThreadSuccess: (
    response: {
      entities: IMessagesSuccessPayload;
      meta: IPaginationMetadata;
    },
    threadId: string
  ) => createAction(EThreadActionType.GET_SUCCESS, { ...response, threadId }),
  resetThread: (threadId: string) =>
    createAction(EThreadActionType.RESET, { threadId }),
  checkPermissionError: (
    threadId: string,
    ...permissions: EThreadPermission[]
  ) =>
    createAction(EThreadActionType.CHECK_PERMISSION_ERROR, {
      threadId,
      permissions,
    }),
  setThreadAsRead: (accountId: string) =>
    createAction(EThreadActionType.SET_AS_READ, { accountId }),
  addMessageToThread: ({
    threadId,
    messageId,
    mainPicture,
    accountId,
  }: IAddMessageToThreadPayload) =>
    createAction(EThreadActionType.NEW_MESSAGE, {
      id: threadId,
      relationships: {
        messages: {
          list: [messageId],
          meta: {},
        },
        mainPicture,
        accountId,
      },
    }),
  deleteUnsentMessage: (payload: { unsentId: string; accountId: string }) =>
    createAction(EThreadActionType.DELETE_UNSENT_MESSAGE, payload),
};

export type TThreadAction = ActionsUnion<typeof threadActions>;

export interface IMessagesSuccessPayload {
  messages: IMessagesEntries;
}

export interface IAddMessageToThreadPayload {
  threadId: string;
  messageId: string;
  mainPicture: string;
  accountId: string;
}

// MULTIPLE THREADS

export enum EThreadsActionType {
  GET = 'THREADS/GET',
  GET_SUCCESS = 'THREADS/GET_SUCCESS',
  RESET = 'THREADS/RESET',
}

export const threadsActions = {
  getThreads: (params: IGetThreadsActionPayload) =>
    createAction(EThreadsActionType.GET, params),
  getThreadsSuccess: (apiThreads: INormalizedThreads) =>
    createAction(EThreadsActionType.GET_SUCCESS, apiThreads),
  resetThreads: () => createAction(EThreadsActionType.RESET),
};

export type TThreadsAction = ActionsUnion<typeof threadsActions>;

export interface IGetThreadsActionPayload {
  reset: boolean;
  resolve?: () => void;
  reject?: () => void;
}
